import { gql, useLazyQuery } from "@apollo/client";

const GET_USER_PROFILES = gql`
    query SparePlayers(
        $q: String
        $sports: [String]
        $location: LocationFilterInput
        $page: Int
        $pageSize: Int
    ) {
        sparePlayers(
            q: $q
            sports: $sports
            location: $location
            page: $page
            pageSize: $pageSize
        ) {
            objects {
                id
                fullName
                address
                city
                state
                country
                latitude
                longitude
                distance
                logoUrl
                user {
                    email
                    mobile
                }
                profileOrganizationsInvited {
                    organization {
                        id
                        name
                    }
                    status
                }
            }
            page
            pages
            hasNext
            hasPrev
        }
    }
`;

export default function GetUserProfiles() {
    return useLazyQuery(GET_USER_PROFILES);
}

